import { fetchMigrationStatus } from '@/data/migration/actions/fetchRipplingMigration';
import RipplingMigrationStatus from '@/data/migration/model';
import MigrationState from '@/data/migration/state';
import generateThunkReducers from '@/data/util/generateThunkReducers';

import { createSlice } from '@reduxjs/toolkit';

const initialState = new MigrationState();

export const migrationSlice = createSlice({
  name: 'ripplingMigration',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchMigrationStatus.fulfilled, (state, action) => {
      const migrationStatus = action.payload ? new RipplingMigrationStatus(action.payload) : null;
      return state.merge({ migrationStatus });
    });
    // Rippling migration status now controls every user's access to WIW. Accounts with cutover status should be
    // prevented from accessing WIW, so we put up a loading overlay while the status loads. If we start getting errors
    // --we don't want to prevent all of our users from accessing our app, so handle rejected thunks as loaded without
    // updating the migrationStatus from its previous value (done below). Yes, cutover accounts could access WIW if the
    // endpoint errors, but that's better than accidentally blocking every single user out of WIW.
    builder.addCase(fetchMigrationStatus.rejected, state => {
      return state.merge({ loaded: true });
    });

    generateThunkReducers(builder, 'ripplingMigration');
  },
});

export default migrationSlice.reducer;
